import React from "react";
import AppModal from "../common/AppModal";
import PostStagedTransactionForm from "../../forms/PostStagedTransactionForm";
import { BankTransactionStagingResponseDto } from "../../shared/dtos/bankTransaction/BankTransactionStagingResponseDto";

interface PostStagedTransactionModalProps {
  open: boolean;
  onClose: () => void;
  stagingRecord: BankTransactionStagingResponseDto;
  loading: boolean;
  error: string | null;
}

const PostStagedTransactionModal: React.FC<PostStagedTransactionModalProps> = ({
  open,
  onClose,
  stagingRecord,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title="Post Bank Transaction"
      width="sm"
      loading={loading}
    >
      <PostStagedTransactionForm
        stagingRecord={stagingRecord}
        loading={loading}
        error={error}
      />
    </AppModal>
  );
};

export default PostStagedTransactionModal;
